let _devise = "EUR";
let _tva = 0.2;

export const setMoneyContext = (space) => {
  _devise = space?.devise || "EUR";
  _tva = typeof space?.tva_rate === "number" ? space.tva_rate : 0.2;
};

export const getDevise = () => _devise;
export const getTvaRate = () => _tva;
export const moneySymbol = () => (_devise === "XOF" ? "FCFA" : "€");
export const tvaLabel = () => `TVA ${String(Math.round(_tva * 1000) / 10).replace(".", ",")} %`;

export const fmtMoney = (n) => {
  const v = Number(n) || 0;
  if (_devise === "XOF") return `${Math.round(v).toLocaleString("fr-FR")} FCFA`;
  return `${v.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
};
